export default "__VITE_ASSET__Q8eDe3BU__"